import { render } from "./ShopLayout.vue?vue&type=template&id=bc50f018"
import script from "./ShopLayout.vue?vue&type=script&lang=js"
export * from "./ShopLayout.vue?vue&type=script&lang=js"

import "./ShopLayout.vue?vue&type=style&index=0&id=bc50f018&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__